import { type LegalClasses, LegalDocumentView } from "@serophin/browser";
import type { LegalDocument } from "@serophin/shared";

const TEXT = "text-gray-700 dark:text-gray-300";

const CLASSES: LegalClasses = {
  article: "px-6 py-12 max-w-6xl mx-auto",
  header: "mb-12",
  title: "text-4xl font-bold mb-4 text-gray-900 dark:text-white",
  lead: `text-lg leading-relaxed mb-4 ${TEXT}`,
  updated: "text-gray-600 dark:text-gray-400",
  contents: "mb-10 p-6 bg-gray-50 dark:bg-neutral-800 rounded-lg",
  contentsTitle: "text-lg font-semibold mb-4",
  contentsList: "grid gap-2",
  contentsLink: "text-blue-600 dark:text-blue-400 hover:underline text-sm",
  section: "mb-10 scroll-mt-6",
  heading: "text-2xl font-semibold mb-4 text-gray-900 dark:text-white",
  subheading: "text-xl font-medium mt-6 mb-3 text-gray-800 dark:text-gray-200 scroll-mt-6",
  paragraph: `mb-4 leading-relaxed ${TEXT}`,
  list: `list-disc pl-6 mb-4 space-y-2 ${TEXT}`,
  orderedList: `list-decimal pl-6 mb-4 space-y-2 ${TEXT}`,
  link: "text-blue-600 dark:text-blue-400 hover:underline",
  strong: "font-medium text-gray-900 dark:text-white",
  closing: "mt-6 text-sm text-center text-gray-600 dark:text-gray-400",
};

export const LegalView = ({ doc }: { doc: LegalDocument }) => (
  <div class="min-h-screen rounded-2xl bg-white dark:bg-neutral-900 text-gray-900 dark:text-gray-100">
    <LegalDocumentView doc={doc} classes={CLASSES} />
  </div>
);
